import React, { useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { CompanyInformationStep } from '../onboarding/steps/CompanyInformationStep';

/**
 * Debug component to test the onboarding validation
 */
export const OnboardingDebug: React.FC = () => {
  const [companyData, setCompanyData] = useState({});
  const [isValid, setIsValid] = useState(false);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Onboarding Validation Debug
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Current State
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Valid: {isValid ? 'YES' : 'NO'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Data: {JSON.stringify(companyData, null, 2)}
        </Typography>
        
        <Button 
          variant="contained" 
          disabled={!isValid}
          sx={{ mb: 2 }}
        >
          Continue (This should enable when form is valid)
        </Button>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <CompanyInformationStep
          data={companyData}
          onChange={setCompanyData}
          onValidationChange={setIsValid}
        />
      </Paper>
    </Box>
  );
};

export default OnboardingDebug;